import React from 'react'
import { Modal, Radio, Button } from 'antd'
import './AudioModeSelectionModal.scss'

const AudioModeSelectionModal = ({
  visible,
  audioMode,
  onModeChange,
  onConfirm
}) => {
  return (
    <Modal
      visible={visible}
      title="Select Audio Generation Mode"
      closable={false}
      maskClosable={false}
      centered
      width={500}
      footer={[
        <Button
          key="submit"
          type="primary"
          onClick={onConfirm}
          disabled={!audioMode}
        >
          Continue
        </Button>
      ]}
      className="audio-mode-modal"
    >
      <div className="audio-mode-modal-content">
        <p className="modal-description">
          Please select how you would like to generate audio for your video.
        </p>

        <Radio.Group
          value={audioMode}
          onChange={onModeChange}
          className="audio-mode-radio-group"
        >
          <div
            className={`mode-option ${
              audioMode === 'narration' ? 'active' : ''
            }`}
          >
            <Radio value="narration">
              <div className="mode-option-content">
                <h4>Narration</h4>
                <p>Quickly generate high-quality audio with minimal setup.</p>
              </div>
            </Radio>
          </div>

          <div
            className={`mode-option ${
              audioMode === 'dialogue' ? 'active' : ''
            }`}
          >
            <Radio value="dialogue">
              <div className="mode-option-content">
                <h4>Dialogue</h4>
                <p>
                  Full control over audio generation, dialogue and narration.
                </p>
              </div>
            </Radio>
          </div>
        </Radio.Group>
      </div>
    </Modal>
  )
}

export default AudioModeSelectionModal
